import * as THREE from 'three';
import { DEG_TO_RAD } from '../config/constants';
import { getSetting, setSetting } from '../settings/userSettings';

export type SwordOrientation = {
  pitchDeg: number;
  yawDeg: number;
  rollDeg: number;
};

export function loadSwordOrientation(): SwordOrientation {
  return {
    pitchDeg: finite(getSetting('swordPitchDeg')),
    yawDeg: finite(getSetting('swordYawDeg')),
    rollDeg: finite(getSetting('swordRollDeg')),
  };
}

export function saveSwordOrientation(o: SwordOrientation): void {
  setSetting('swordPitchDeg', o.pitchDeg);
  setSetting('swordYawDeg', o.yawDeg);
  setSetting('swordRollDeg', o.rollDeg);
}

/** Applies orientation to the sword group in controller-local space. */
export function applySwordOrientation(sword: THREE.Object3D, o: SwordOrientation): void {
  sword.rotation.set(o.pitchDeg * DEG_TO_RAD, o.yawDeg * DEG_TO_RAD, o.rollDeg * DEG_TO_RAD);
}

function finite(n: number): number {
  return Number.isFinite(n) ? n : 0;
}
